module.exports = __webpack_public_path__ + "img/移动App定制iOSAndroid.5ee6ece2.png";